import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-8 w-full rounded-control border border-input bg-paper px-3 py-1 text-[13px] text-ink transition-colors file:border-0 file:bg-transparent file:text-[13px] file:font-medium file:text-foreground placeholder:text-ink-tertiary focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
